import React from 'react';
import { useParams } from 'react-router-dom';
import Button from 'components/Button';
import PageContainer from 'components/PageContainer';
import Summary from '../Common/Summary';
import { INVESTOR_REPORTING } from 'adminConstants/routes';
import { useDeploymentUpdateView } from 'hooks/data/deploymentUpdate/useDeploymentUpdate';
import PageContent from 'components/PageContent';
import api from 'lib/trpcClient';
import { useGetRole } from 'hooks/ui/useGetRole';
import useHandleTrpcMutation from 'hooks/ui/useHandleTrpcMutation';
import { Row } from 'components/Layout';
import Spacing from 'components/Spacing';

const ViewCustomUpdate: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { isSuperAdmin } = useGetRole();
  const { data: deploymentUpdate } = useDeploymentUpdateView(id);
  const resendEmails = api.deploymentUpdate.resendEmails.useMutation(
    useHandleTrpcMutation()({
      successMessage: 'Deployment update emails sent successfully.',
    }),
  );
  const breadcrumbs = [
    { label: 'Dashboard', link: '/' },
    {
      label: 'Investor Reporting',
      link: INVESTOR_REPORTING,
    },
  ];
  const heading = 'Investor reporting: View deployment update';

  const handleResendEmails = () => {
    if (id) {
      resendEmails.mutate({ deploymentUpdateId: id });
    }
  };

  return (
    <PageContainer heading={heading} breadcrumbs={breadcrumbs}>
      <PageContent header="Deployment update summary">
        <Summary
          data={deploymentUpdate ?? undefined}
          company={deploymentUpdate?.companyId}
        />
        {isSuperAdmin && (
          <Spacing size="md">
            <Row justify="flex-end">
              <Button
                variant="outlined"
                onClick={handleResendEmails}
                disabled={!id || resendEmails.isPending}
                loading={resendEmails.isPending}
              >
                Resend deployment update emails
              </Button>
            </Row>
          </Spacing>
        )}
      </PageContent>
    </PageContainer>
  );
};

export default ViewCustomUpdate;
